<template>
    <div class="templete no_print">
            <div class="path_title clearfix">
                <span class="path_title_name">定价设置</span>
                <!-- <div class="contractLabel" style="position:relative;">
                    <span class="redQuestion"></span>
                    <div class="labelTip">
                        <div class="labelZhu">注:</div>
                        <div class="laCbelTipC">在码单立方和检尺立方中选择其中最低方数 x [ ? ]  为可销售立方下限值</div>
                    </div>
                </div> -->
            </div>
            <div class="box">
                <span>最低价=挂牌价减</span>
                <el-input class="input_box" v-model="min_price" @blur="timeChange" placeholder="" size="mini"></el-input>
            </div>
            <div class="box">
                <span>不开票价=最低价</span>
                <el-select  placeholder="fx" v-model="rec_type" style="width: 60px;margin-left: 10px;" @blur="timeChange">
                    <el-option :value="'SUB'" label="-"></el-option>
                    <el-option :value="'MUL'" label="×"></el-option>
                </el-select>
                <el-input class="input_box" v-model="rec" @blur="timeChange" placeholder="" size="mini" style="margin:0px;"></el-input>
            </div>
            <div class="path_switch">
                <el-radio-group v-model="radio" @change="timeChange">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </div>
            <div class="box">
                <span>销售单价=采购单价</span>
            </div>
            <div class="path_switch">
                <el-radio-group v-model="price_radio" @change="priceChange">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
            </div>
         </div>
</template>
<style scoped lang="scss">
    .templete{overflow: auto;}
    .contractLabel{float: left;position: relative;top:3px;margin-left:10px;}
    .path_title_name{float: left;}
    .redQuestion{display: block;width:15px;height:15px;background: url('/icon/question.png') no-repeat 100%;background-size: 100% 100%;}
    .labelTip{display: none;position: absolute;top:20px;left:-150px;z-index:1;width:200px;text-align: left;background-color: #fff;border-radius: 4px;padding:10px;box-sizing: border-box;box-shadow: 1px 1px 5px #ccc;padding-left:30px;}
    .laCbelTipC{color:#606266;font-size: 12px;}
    .labelZhu{font-size: 12px;color:#b21111;position: absolute;top:10px;left:10px;}
    .contractLabel:hover{cursor: pointer;}
    .contractLabel:hover .labelTip{display: block;}
    .path_title{text-align: left;
        font-size:16px; font-weight:bold; margin-top: 26px;margin-bottom:20px;
        & + div{ margin-bottom: 20px; color: #333333; display: flex; align-items: center; }
    }
    .box{ margin-bottom: 20px; color: #333333; display: flex; align-items: center; }
    .input_box{ width:80px; margin: 0 10px; }
    .container{
        padding: 34px 30px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
    }
    .path_switch{text-align: left;margin-bottom:20px;}
    .path{
            margin-bottom: 7px; display: flex; align-items: center; justify-content: space-between;
            .title{
                font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #b21111; padding-left: 12px;
            }
        }
    .table_path{ flex: 1; box-shadow:0px 0px 10px rgba(94,94,94,0.16); border-radius:3px; width: 100%; padding: 8px 10px;  }
    .el-icon-refresh{margin-right:10px;cursor: pointer;color:#F9A602;font-weight: 600;}
    .gradeSection{width:700px;flex: 1;display: flex;flex-direction: column;}
    // .starList{margin-bottom:10px;}
    .starTableList .gradeStar{position: relative;top:5px;float: left;}
    .gradeStar{margin-right: 10px;margin-bottom:10px;}
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                radio : "",
                rec:0,
                rec_type:'SUB',
                min_price:0,
                price_radio:"",
            }
        },
        created(){
            this.getDataA();
            this.getDataB();
        },
        methods:{
            getDataA(){
                this.postFunc("/erp/system.get.config",{key:"AUTO_MINI_PRICE"},res=>{
                    this.radio = res.data.data.status;
                    this.min_price = res.data.data.value.min_price;
                    this.rec = res.data.data.value.rec;
                    this.rec_type = res.data.data.value.rec_type;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getDataB(){
                this.postFunc("/erp/system.get.config",{key:"ENABLE_PURCHASE_PRICE"},res=>{
                    this.price_radio = res.data.data.status;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            timeChange(){
                this.postFunc("/erp/system.set.config",{key:"AUTO_MINI_PRICE",status:this.radio,value:{min_price:this.min_price,rec:this.rec,rec_type:this.rec_type}},()=>{
                    this.tip("操作成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            priceChange(){
                this.postFunc("/erp/system.set.config",{key:"ENABLE_PURCHASE_PRICE",status:this.price_radio},()=>{
                    this.tip("操作成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
        }
    }
</script>
